export default "__VITE_ASSET__4b575c82__"